const typographyStyle = theme => ({
    fontFamily: ({ fontFamily }) => ({ fontFamily }),
    fontStyle: ({ fontStyle }) => ({ fontStyle }),
    disabled: { color: theme.palette.text.disabled },
});

export default typographyStyle;
